module.exports = __webpack_public_path__ + "img/cover.ebb2cc7e.png";